export const LOGO_URL = "https://customer-assets.emergentagent.com/job_service-reserve-23/artifacts/z0mmh7k9_AUTO%20BASIC%20CARE%20PNG.png";
